import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HtmlSplitterHelper {
  static split(html: string): string[] {
    if (!html) return [];

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const chunks: string[] = [];

    // Iterate over top-level children of the body
    Array.from(doc.body.childNodes).forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        // Elements like <h1>, <p>, <div>, etc.
        const element = node as HTMLElement;
        // Check if it's an empty paragraph or similar filler
        if (element.textContent?.trim() !== '' || element.querySelector('img')) {
          chunks.push(element.outerHTML);
        }
      } else if (node.nodeType === Node.TEXT_NODE) {
        // Loose text nodes
        const text = node.textContent?.trim();
        if (text) {
          chunks.push(`<p>${text}</p>`);
        }
      }
    });

    return chunks;
  }
}
